import { useCallback } from 'react'
import { useHistory, useLocation, stringifyQuery } from '@fs/zion-router'

export default function useRouterHelper() {
  const history = useHistory()
  const location = useLocation()

  const navigate = useCallback(
    ({ path = location.pathname, query, replaceState = false }) => {
      const queryString = query ? `?${stringifyQuery(query)}` : ''
      const url = path + queryString
      if (replaceState) {
        history.replace(url)
      } else {
        history.push(url)
      }
    },
    [history, location]
  )

  return { navigate }
}
